import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';

export const getAllDoseDictionary = (): any =>
  api()
    .get(`/portal-api/studyDose/dictionary/getAll`)
    .then((response) => get(response, 'data'))
    .catch((error) => false);
